import { styled } from 'styled-components';

// The heading for the text itself
export const Title = styled.h5`
  color: var(--color-text-light);
  padding: var(--spacing-large) 0;
  text-align: center;
`;
